export default __webpack_public_path__ + "static/media/inform_logo.ee96db2e.png";